import { render, staticRenderFns } from "./StartingRules.vue?vue&type=template&id=39137005&scoped=true"
import script from "./StartingRules.vue?vue&type=script&lang=js"
export * from "./StartingRules.vue?vue&type=script&lang=js"
import style0 from "./StartingRules.vue?vue&type=style&index=0&id=39137005&prod&lang=scss"
import style1 from "./StartingRules.vue?vue&type=style&index=1&id=39137005&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39137005",
  null
  
)

export default component.exports